import App from './app';

export default function authService($q) {
  'ngInject';
  var isRefreshingToken = false;
  return {
    requestRefreshToken: function () {
      //Return a promise cuz promises are awesome
      var def = $q.defer();

      //Perform a synchronous request ajax call to get the new acccess token!
      $.ajax({
        type: 'POST',
        url: '/home/RefreshToken/',
        data: App.getRefreshToken(),
        async: false,
        success: function (response) {
          isRefreshingToken = false;
          //Swap out the tokens
          App.setToken(response['accessToken']);
          App.setRefreshToken(response['refreshToken']);
          // console.log("Swapped out refresh tokens");
          return def.resolve(response);
        },
        error: function (response) {
          isRefreshingToken = false;
          return def.reject(response);
        },
        dataType: 'json'
      });
      return def.promise;
    }
  };
}